export const SHOW_MODAL = '@@modal/SHOW_MODAL'
export const HIDE_MODAL = '@@modal/HIDE_MODAL'

export interface ModalState {
	name: string;
	context?: unknown;
}

export interface Modal {
	name: string;
	context?: unknown;
}

interface ShowModalAction {
	type: typeof SHOW_MODAL;
	payload: Modal;
}

interface HideModalAction {
	type: typeof HIDE_MODAL;
}

export type ModalActionTypes = ShowModalAction | HideModalAction
